import backofficeService from '@/api/backoffice.js'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('year', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllPayeeExpenseTotal(params) {
    return backofficeService.Api().get('year/totalExpense', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`year/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('year', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`year/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  unlockReportCards(id) {
    return backofficeService.Api().put(`year/${id}/unlock-report-cards`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`year/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getCalendarEvents(YearId) { return backofficeService.Api().get('calendar/events', { params: { YearId } }).then(response => response.data) },
  createCalendarEvent(data) { return backofficeService.Api().post('calendar/events', data).then(response => response.data) },
  updateCalendarEvent(id, data) { return backofficeService.Api().put(`calendar/events/${id}`, data).then(response => response.data) },
  deleteCalendarEvent(id) { return backofficeService.Api().delete(`calendar/events/${id}`).then(response => response.data) },
  getCalendarOccasions(ClassId) { return backofficeService.Api().get('calendar/occasions', { params: { ClassId } }).then(response => response.data) },
  createCalendarOccasion(data) { return backofficeService.Api().post('calendar/occasions', data).then(response => response.data) },
  updateCalendarOccasion(id, data) { return backofficeService.Api().put(`calendar/occasions/${id}`, data).then(response => response.data) },
  deleteCalendarOccasion(id) { return backofficeService.Api().delete(`calendar/occasions/${id}`).then(response => response.data) },
  copyCalendar(yearId, data) { return backofficeService.Api().post(`calendar/${yearId}/copy`, data).then(response => response.data) },
  publishCalendar(yearId) { return backofficeService.Api().post(`calendar/${yearId}/publish`).then(response => response.data) },

}
